import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useLazyVerifyQuery } from "../../../Store/Builder/techsbook.api";
import { setLoader } from "../../../Store/Slice/techsbookSlice";
import showToast from "../../Hooks/toast";

const useVerifyEmailApi = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [verify] = useLazyVerifyQuery();

  const send = (data) => {
    dispatch(setLoader(true));
    verify({ ...data, verify_token: location?.state?.verify_token })
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        showToast(res?.message ?? "Success", "success");
        const route = "/create-password";
        navigate(route, {
          state: {
            ...res,
            method: location?.state?.method === "signup" ? "signup" : "",
          },
        });
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error", "error");
      });
  };
  return {
    send,
  };
};

export default useVerifyEmailApi;
